import './NavCardBadge.css'
function NavCardBadge({number}) {
    return (
      <div className="project_nmbrs">
      <p>{number}</p>
    </div>
    )
  }
  
  export default NavCardBadge